import * as types from './actionTypes'

export const initCollection = (id, page, record) => ({
    type: types.INIT_COLLECTION,
    id,
    page,
    record
})

export const collectionSuccess = (data, views) => ({
    type: types.INIT_COLLECTION_SUCCESS,
    data,
    views
})

export const collectionFailed = () => ({
    type: types.INIT_COLLECTION_FAILED
})

export const setCollectionView = (viewId) => ({
    type: types.SET_COLLECTION_VIEW,
    viewId
})

export const fetchReorderColumns = (columns) => ({
    type: types.REORDER_COLUMNS_FETCH,
    columns
})

export const fetchResizeColumn = (field, width) => ({
    type: types.RESIZE_COLUMN_FETCH,
    field,
    width
})

export const fetchLockCol = (field) => ({
    type: types.LOCK_COL_FETCH,
    field
})

export const toggleFieldSort = (field) => ({
    type: types.TOGGLE_SORT_FETCH,
    field
})

export const toggleFieldHide = (field) => ({
    type: types.TOGGLE_HIDE_FETCH,
    field
})

export const setFilters = (filters, save) => ({
    type: types.SET_FILTERS_FETCH,
    filters,
    save
})

export const updateViewStateSuccess = () => ({
    type: types.VIEW_STATE_UPDATE_SUCCESS
})

export const updateViewStateFailed = () => ({
    type: types.VIEW_STATE_UPDATE_FAILED
})

export const fetchDocumentAdd = () => ({
    type: types.DOCUMENT_ADD_FETCH
})

export const fetchDocumentAddSuccess = (data) => ({
    type: types.DOCUMENT_ADD_SUCCESS,
    data
})

export const fetchDocumentAddFailed = () => ({
    type: types.DOCUMENT_ADD_FAILED
})

export const fetchDocumentDelete = (records) => ({
    type: types.DOCUMENT_DELETE_FETCH,
    records
})

export const fetchDocumentDeleteSuccess = () => ({
    type: types.DOCUMENT_DELETE_SUCCESS
})

export const fetchDocumentDeleteFailed = () => ({
    type: types.DOCUMENT_DELETE_FAILED
})

export const selectionChange = (selected) => ({
    type: types.DOCUMENT_SELECTION_CHANGE,
    selected
})

export const fetchDocumentUpdate = (record, fieldId, value) => ({
    type: types.DOCUMENT_UPDATE_FETCH,
    record,
    fieldId,
    value
})

export const resetCreatedRow = () => ({
    type: types.RESET_CREATED_ROW
})

export const setTextFilter = (pattern) => ({
    type: types.SET_TEXT_FILTER,
    pattern
})

export const setTextFilterSuccess = () => ({
    type: types.SET_TEXT_FILTER_SUCCESS
})

export const setTextFilterFailed = () => ({
    type: types.SET_TEXT_FILTER_FAILED
})

export const fetchDocumentsUpdate = (records, fieldId, value) => ({
    type: types.DOCUMENTS_UPDATE_FETCH,
    records,
    fieldId,
    value
})

export const setFeedback = (id) => ({
    type: types.SET_FEEDBACK,
    id
})

export const setFeedbackSuccess = () => ({
    type: types.SET_FEEDBACK_SUCCESS
})

export const setFeedbackFailed = () => ({
    type: types.SET_FEEDBACK_FAILED
})

export const toggleReadonly = (field) => ({
    type: types.TOGGLE_READONLY,
    field
})

export const createView = (config, id, value) => ({
    type: types.CREATE_VIEW_FETCH,
    config,
    id,
    value
})

export const createViewSuccess = (data) => ({
    type: types.CREATE_VIEW_SUCCESS,
    data
})

export const createViewFailed = () => ({
    type: types.CREATE_VIEW_FAILED
})

export const handleSelectView = (viewId) => ({
    type: types.SELECT_VIEW,
    viewId
})

export const deleteView = (id, viewId, value) => ({
    type: types.DELETE_VIEW_FETCH,
    id,
    viewId,
    value
})

export const deleteViewSuccess = (data, viewId) => ({
    type: types.DELETE_VIEW_SUCCESS,
    data,
    viewId
})

export const deleteViewFailed = () => ({
    type: types.DELETE_VIEW_FAILED
})

export const updateView = (config, id) => ({
    type: types.UPDATE_VIEW_FETCH,
    config,
    id
})

export const updateViewSuccess = (data) => ({
    type: types.UPDATE_VIEW_SUCCESS,
    data
})

export const updateViewFailed = () => ({
    type: types.UPDATE_VIEW_FAILED
})

export const reorderViews = (id, order) => ({
    type: types.REORDER_VIEWS_FETCH,
    id,
    order
})

export const reorderViewsSuccess = (data) => ({
    type: types.REORDER_VIEWS_SUCCESS,
    data
})

export const reorderViewsFailed = () => ({
    type: types.REORDER_VIEWS_FAILED
})

export const resetViews = () => ({
    type: types.RESET_VIEWS
})

export const cloneView = (viewId, id) => ({
    type: types.VIEW_CLONE_FETCH,
	viewId,
    id
})

export const cloneViewSuccess = (data) => ({
    type: types.VIEW_CLONE_SUCCESS,
    data
})

export const cloneViewFailed = () => ({
    type: types.VIEW_CLONE_FAILED
})
